import globals from "../../globlas";
import { _sendWithAxios, _sendWithAxiosBlob } from "../api";

const REACT_APP_URL_BASE_API = globals.REACT_APP_URL_BASE_API;

export const buscarUsuarios = async (tamanho = 1, pagina = 10000, nomeUsuario) => {
  let usuario = nomeUsuario ? nomeUsuario : "";
  return await _sendWithAxios(
    `${REACT_APP_URL_BASE_API}Usuario/usuarios/${tamanho}/${pagina}/?usuario=${usuario}`,
    "GET"
  );
};

export const detalhesUsuario = async (usuarioId) => {
  return await _sendWithAxios(
    `${REACT_APP_URL_BASE_API}Usuario/detalhe-usuario/${usuarioId}`,
    "GET"
  );
};

export const editarUsuario = async (data) => {
  return await _sendWithAxios(
    `${REACT_APP_URL_BASE_API}Usuario/editar-usuario`,
    "POST",
    data
  );
};

export const listarPermissoes = async (somenteConfiguravel = false) => {
  return await _sendWithAxios(
    `${REACT_APP_URL_BASE_API}Usuario/permissoes?somenteConfiguravel=${somenteConfiguravel}`,
    "GET"
  );
};
export const permissoesPaginados = async (page, pageSize, nomePermissao) => {
  let permissao = nomePermissao ? nomePermissao : "";
  return await _sendWithAxios(
    `${REACT_APP_URL_BASE_API}Permissao/listar-permissoes/${pageSize}/${page}/?permissao=${permissao}`,
    "GET"
  );
};

export const listarUsuariosQuePossuiPermissoesPaginados = async (id) => {
  return await _sendWithAxios(
    `${REACT_APP_URL_BASE_API}Permissao/listar-permissoes/${id}/${100000000}/${1}`,
    "GET"
  );
};

export const usuariosPaginados = async (page, size, nomeUsuario = "") => {
  let url = `${REACT_APP_URL_BASE_API}Usuario/listagem/${page}/${size}`;
  if (nomeUsuario) {
    url += `?filter=${encodeURIComponent(nomeUsuario)}`;
  }
  return await _sendWithAxios(url, "GET");
};
export const logarUsuario = async (obj = "") => {
  return await _sendWithAxios(
    `${globals.REACT_APP_APIBASE_LOGIN}identidade/portal/autenticar`,
    "POST",
    obj
  );
};
export const logarUsuarioMidiaCenter = async (obj = "") => {
  return await _sendWithAxios(
    `${globals.REACT_APP_APIBASE_LOGIN}identidade/integracao`,
    "GET",
    obj
  );
};
